// Interfaces from Global Models
export interface UserLite {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
}

export interface StatusHistoryEntry<T> {
  date: Date;
  status: T;
  user: UserLite;
  comment?: string;
}

export interface Note {
  id?: string;
  content: string;
  createdBy: string;
  createdDate: Date;
}

// Enums
export enum InventoryAdjustmentStatus {
  Draft = 0,
  Completed = 1,
  Voided = 2,
}

export enum AdjustmentType {
  LocationTransfer = 0,
  QuantityCorrection = 1,
  LocationAndQuantity = 2,
}

export enum UnitOfMeasure {
  kg = 0,
  m = 1,
  unit = 2,
  lb = 3,
  L = 4,
  yd = 5,
  g = 6,
  gal = 7,
  box = 8,
  pack = 9,
  bkt = 10,
  rl = 11,
  pc = 12,
  thr = 13,
  ft = 14,
  set = 15,
  kit = 16,
  pair = 17,
  btl = 18,
  qt = 19,
  sck = 20,
  bag = 21,
  tub = 22,
  oz = 23,
  drm = 24,
}

// DTOs
export interface InventoryAdjustmentDto {
  id?: string;
  number?: string;
  status: InventoryAdjustmentStatus;
  type: AdjustmentType;
  reason: string;
  lines?: InventoryAdjustmentLineDto[];
  statusHistory: StatusHistoryEntry<InventoryAdjustmentStatus>[];
  notes: Note[];
  createdBy?: string;
  createdDate?: Date;
  modifiedBy?: string;
  modifiedDate?: Date;
}

export interface InventoryAdjustmentLineDto {
  lineId: string;
  lotItemNumber: string;
  fromLocationCode?: string;
  toLocationCode?: string;
  quantityAdjustment?: number;
  uom: UnitOfMeasure;
  comments?: string;
}

// Commands
export interface InventoryAdjustmentInsert {
  status?: InventoryAdjustmentStatus;
  type: AdjustmentType;
  reason: string;
  lines?: InventoryAdjustmentLineDto[];
  notes?: Note[];
}

export interface InventorySearchCommandBase {
  warehouseCode?: string;
  locationCode?: string;
  itemCode?: string;
  lotItemNumber?: string;
  startDate?: string;
  endDate?: string;
  status?: InventoryAdjustmentStatus;
  skip?: number;
  take?: number;
}

// Lot-Based Adjustment Interfaces
export interface LotBasedAdjustmentRequest {
  providerLotId: string;
  reductionAmount: number;
  uom?: UnitOfMeasure;
  reason: string;
  locationCode: string;
  comments?: string;
}

export interface LotBasedAdjustmentResponse {
  providerLotId: string;
  balanceBefore: number;
  balanceAfter: number;
  totalReduced: number;
  uom: UnitOfMeasure;
  processedLotItems: ProcessedLotItemDetail[];
  adjustment?: InventoryAdjustmentDto;
}

export interface ProcessedLotItemDetail {
  lotItemNumber: string;
  itemCode: string;
  quantityBefore: number;
  amountReduced: number;
  quantityAfter: number;
  locationCode: string;
  dateReceived?: Date;
}

export interface LotBalanceSummary {
  providerLotId: string;
  itemCodes: string[];
  totalBalance: number;
  lotItemCount: number;
  uom: UnitOfMeasure;
  lotItems: LotItemSummary[];
}

export interface LotItemSummary {
  lotItemNumber: string;
  itemCode: string;
  netQuantity: number;
  locationCode: string;
  dateReceived?: Date;
  isActive: boolean;
}
